module.exports = __webpack_public_path__ + "img/norrtag-felbokning.5f2211d8.png";